import { useFormik } from 'formik'
import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import styled from 'styled-components'
import * as Yup from 'yup'
import api from '../../../api'
import Responsive from '../../../assets/config/Responsive'
import Colors from '../../../assets/styles/Colors'
import Loader from '../../../components/Loader'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import Dropdown from '../../../components/v2/Dropdown'
import GenderCard from '../../../components/v2/GenderCard'
import Input from '../../../components/v2/Input'
import MovingPrice from '../../../components/v2/MovingPrice'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import Title from '../../../components/v2/Title'
import WarningMessage from '../../../components/v2/WarningMessage'
import Checkbox from '../../../components/v2/buttons/Checkbox'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import DialogModal from '../../../components/v2/modals/DialogModal'
import WelcomerProgressbar from '../../../components/v2/progrees-bars/WelcomerProgressbar'
import { RootState, useAppSelector } from '../../../store'
import { AppState } from '../../../store/appSlice'
import { AuthState } from '../../../store/authSlice'
import { WelcomerState, setInsurerInfo, setInsurerObj, setInsurerTranslationInfo } from '../../../store/welcomerSlice'
import { Helmet } from 'react-helmet-async'

const WelcomerForMe = () => {
  //
  const { lang, isProduction } = useAppSelector((root: { app: AppState }) => root.app)
  //
  const { t } = useTranslation()
  //
  const navigate = useNavigate()
  //
  const dispatch = useDispatch()
  //
  const { filter, screenHeader, checkout } = useAppSelector((data: { welcomer: WelcomerState }) => data.welcomer)
  //
  const { data: pageInfo, isLoading: isPageInfoLoading } = api.useGetWelcomerPagesInfoQuery('welcomer-personal-info')
  //
  const pageTitle = pageInfo?.translations?.[lang]?.title
  const stepName = pageInfo?.translations?.[lang]?.stepName
  //
  //
  const auth = useSelector<RootState, AuthState>((state) => state.auth)
  //
  // countries array from api
  const { data: countries, isLoading: isCountriesLoading } = api.useGetCountriesQuery(undefined)
  //
  // Sgs request
  const [sgsRequest, { isLoading: isSgsRequestLoaiding, data: sgsResult }] = api.useSgsRequestMutation()
  //
  const [termsModalIsOpen, setTermsModalIsOpen] = useState<boolean>(false)
  //
  const closeTermsModal = () => {
    setTermsModalIsOpen(false)
  }
  //
  //
  const formatDate = (dateString: any) => {
    const parts = dateString.split('-')!
    const formattedDate = `${parts[2]} / ${parts[1]} / ${parts[0]}`
    return formattedDate
  }
  //
  const formattedDateString = formatDate(auth.user?.birthday || '')
  //
  //
  // ######################################################## set insurer obj from profile
  //
  //
  // SGS & set user info from SGS & if user not logged
  const requestSgsAndResponseData = useCallback(async () => {
    const loggedUserNotHaveSgsVerification =
      auth &&
      auth.user &&
      auth.user.userType === 'User' &&
      isProduction &&
      auth.user.sgsVerification === false &&
      !checkout.insurer.sgsVerification &&
      !checkout.insurer.sgsVerificationSended &&
      checkout.insurer.cityzenship === 'GE' &&
      checkout.insurer.dateOfbirth &&
      checkout.insurer.idNumber &&
      checkout.insurer.idNumber.length === 11

    //
    const newUserSgsVerification =
      auth &&
      isProduction &&
      (!auth.user || (auth.user && auth.user.userType && auth.user.userType !== 'User')) &&
      !checkout.insurer.sgsVerification &&
      !checkout.insurer.sgsVerificationSended &&
      checkout.insurer.cityzenship === 'GE' &&
      checkout.insurer.dateOfbirth &&
      checkout.insurer.idNumber &&
      checkout.insurer.idNumber.length === 11
    //
    if (loggedUserNotHaveSgsVerification || newUserSgsVerification) {
      //
      // Convert the input date string to a JavaScript Date object
      const dateParts = filter.welcomersDate?.[0]?.date?.split('/').map((part) => part.trim())
      const formattedDate = dateParts && new Date(`${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`)

      // Format the date to "YYYY-MM-DD"
      const formattedDateString = formattedDate && formattedDate?.toISOString()?.split('T')[0]
      //
      if (formattedDateString && checkout.insurer.idNumber && isProduction) {
        //
        dispatch(
          setInsurerInfo({
            fieldName: 'sgsVerificationSended',
            fieldValue: true,
          }),
        )
        //
        try {
          //
          await sgsRequest({ birthday: formattedDateString, personalNumber: checkout.insurer.idNumber }).unwrap()
          //
        } catch (error: any) {
          if (error?.data?.errors?.constructor === Array) {
            const firstError = error.data.errors[0]
            const errorMessage = firstError.message
            toast.error(errorMessage)
          }
        }
      }
      //
    }
    //
  }, [
    filter.welcomersDate,
    isProduction,
    auth,
    checkout.insurer.cityzenship,
    checkout.insurer.dateOfbirth,
    checkout.insurer.idNumber,
    checkout.insurer.sgsVerification,
    checkout.insurer.sgsVerificationSended,
    sgsRequest,
    dispatch,
  ])
  //
  // send SGS request
  useEffect(() => {
    requestSgsAndResponseData()
    //
    return () => {}
  }, [requestSgsAndResponseData])
  //
  //
  //
  const setSgsUserDataCallBack = useCallback(() => {
    //
    // set sgs response data
    if (isProduction && sgsResult && sgsResult.sgsStatusText && sgsResult.sgsStatusText.toLowerCase() === 'ok') {
      return [
        dispatch(
          setInsurerObj({
            cityzenship: checkout.insurer.cityzenship,
            dateOfbirth: checkout.insurer.dateOfbirth,
            passportNumber: checkout.insurer.passportNumber,
            idNumber: checkout.insurer.idNumber,
            gender: sgsResult.gender,
            sgsVerification: true,
            sgsVerificationSended: true,
            translations: {
              ge: {
                firstName: sgsResult.translations?.ge?.firstName,
                lastName: sgsResult.translations?.ge?.lastName,
              },
              en: {
                firstName: sgsResult.translations?.en?.firstName || '',
                lastName: sgsResult.translations?.en?.lastName || '',
              },
            },
          }),
        ),
      ]
    }
  }, [
    checkout.insurer.cityzenship,
    checkout.insurer.dateOfbirth,
    checkout.insurer.idNumber,
    checkout.insurer.passportNumber,
    sgsResult,
    isProduction,
    dispatch,
  ])
  //
  //
  useEffect(() => {
    setSgsUserDataCallBack()
    //
    return () => {}
  }, [setSgsUserDataCallBack])
  //
  //
  //
  const setUserCallBack = useCallback(() => {
    //
    // set user info from logged user & if user is logged
    if (
      auth &&
      auth.user &&
      auth.user.userType &&
      auth.user.userType === 'User' &&
      !checkout.insurer.sgsVerificationSended
    ) {
      return [
        dispatch(
          setInsurerObj({
            cityzenship: auth.user.citizenship,
            dateOfbirth: formattedDateString as unknown as Date,
            passportNumber: auth.user.passportNumber,
            idNumber: auth.user.personalNumber,
            gender: auth.user.gender,
            consentTerm: auth.user.agreeToTerms.consentTerm,
            privacyTerm: auth.user.agreeToTerms.privacyTerm,
            translations: {
              ge: {
                firstName: auth?.user?.firstNameGe,
                lastName: auth?.user?.lastNameGe,
              },
              en: {
                firstName: auth?.user?.firstName,
                lastName: auth?.user?.lastName,
              },
            },
          }),
        ),
      ]
    }
    //
    //
  }, [auth, formattedDateString, dispatch, checkout.insurer.sgsVerificationSended])
  //
  //
  useEffect(() => {
    setUserCallBack()
    return () => {}
  }, [setUserCallBack])
  //
  // ######################################################## set insurer obj from profile
  //
  // ######################################################## set insurer date
  const setInsurerDateCallBack = useCallback(() => {
    dispatch(
      setInsurerInfo({
        fieldName: 'dateOfbirth',
        fieldValue: filter?.welcomersDate?.[0]?.date,
      }),
    )
  }, [dispatch, filter?.welcomersDate])
  //
  //
  useEffect(() => {
    setInsurerDateCallBack()
    return () => {}
  }, [setInsurerDateCallBack])
  // ######################################################## set insurer date
  //
  //
  //
  //
  // english letter regex
  const englishLetterRegex = /^[A-Za-z]+$/
  //
  const georgianLetterRegex = /^[\u10D0-\u10FF]*$/
  //
  // yup validations schema
  const PersonalInfoValidationSchema = Yup.object({
    citizenship: Yup.string().required(`${t('required')}`),
    firstName: Yup.string()
      .min(2, `${t('minNameLetterLenght')}`)
      .matches(/^\S*$/, `${t('spaceValidation')}`)
      .matches(englishLetterRegex, `${t('onlyEnglishLetters')}`)
      .required(`${t('required')}`),
    lastName: Yup.string()
      .min(2, `${t('minSurnameLetterLenght')}`)
      .matches(/^\S*$/, `${t('spaceValidation')}`)
      .matches(englishLetterRegex, `${t('onlyEnglishLetters')}`)
      .required(`${t('required')}`),
    firstNameGe: Yup.string().when('citizenship', {
      is: (citizenship: string) => citizenship === 'GE',
      then: Yup.string()
        .min(2, `${t('minNameLetterLenght')}`)
        .matches(georgianLetterRegex, `${t('onlyGeorgianLetters')}`)
        .required(`${t('required')}`),
      otherwise: Yup.string().notRequired(),
    }),

    lastNameGe: Yup.string().when('citizenship', {
      is: (citizenship: string) => citizenship === 'GE',
      then: Yup.string()
        .min(2, `${t('minNameLetterLenght')}`)
        .matches(georgianLetterRegex, `${t('onlygeorgianletters')}`)
        .required(`${t('required')}`),
      otherwise: Yup.string().notRequired(),
    }),
    idNumber: Yup.string().when('citizenship', {
      is: (citizenship: string) => citizenship === 'GE',
      then: Yup.string()
        .matches(/^\S*$/, `${t('spaceValidation')}`)
        .matches(/^[0-9]+$/, `${t('numberValidation')}`)
        .min(11, `${t('personalNumberValidation')}`)
        .max(11, `${t('personalNumberValidation')}`)
        .nullable()
        .required(`${t('required')}`),
      otherwise: Yup.string()
        .matches(/^[a-zA-Z0-9]*$/, `${t('letterNumberValidation')}`)
        .notRequired()
        .nullable(),
    }),
    gender: Yup.string()
      .matches(/^\S*$/, `${t('spaceValidation')}`)
      .required(`${t('required')}`),
    passportNumber: Yup.string().when('citizenship', {
      is: (citizenship: string) => citizenship !== 'GE',
      then: Yup.string()
        .matches(/^\S*$/, `${t('spaceValidation')}`)
        .matches(/^[a-zA-Z0-9]*$/, `${t('letterNumberValidation')}`)
        .nullable()
        // .max(9, `${t('passportNumberValidation')}`)
        .required(`${t('required')}`),
      otherwise: Yup.string()
        .matches(/^\S*$/, `${t('spaceValidation')}`)
        .matches(/^[a-zA-Z0-9]*$/, `${t('letterNumberValidation')}`)
        .max(9, `${t('passportNumberValidation')}`)
        .nullable(),
    }),
  })
  //
  //
  //
  const MainValidationSchema = PersonalInfoValidationSchema
  //
  //
  // initial values
  const initialValues = {
    citizenship: checkout.insurer.cityzenship || '',
    firstName: checkout.insurer.translations?.en?.firstName || '',
    lastName: checkout.insurer.translations?.en?.lastName || '',
    firstNameGe: checkout.insurer.translations?.ge?.firstName || '',
    lastNameGe: checkout.insurer.translations?.ge?.lastName || '',
    idNumber: checkout.insurer.idNumber || null,
    gender: checkout.insurer.gender || '',
    passportNumber: checkout.insurer.passportNumber || null,
  }
  // formi state
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: MainValidationSchema,
    enableReinitialize: true,
    validateOnChange: true,
    onSubmit: (values) => {
      console.log(values)
    },
  })
  //
  // get diff age function
  const calculateAgeFromDate = (dateString: any) => {
    if (typeof dateString === 'string') {
      // Remove any whitespace from the string
      dateString = dateString.replace(/\s/g, '')

      // Extract day, month, and year from the string
      var parts = dateString.split('/')
      var birthDate = new Date(parts[2], parts[1] - 1, parts[0])

      // Calculate the difference in years
      var ageDiff = Date.now() - birthDate.getTime()
      var ageDate = new Date(ageDiff)

      return Math.abs(ageDate.getUTCFullYear() - 1970)
    }

    return null
  }
  //
  const diffage = calculateAgeFromDate(checkout.insurer?.dateOfbirth)
  //
  //
  // auto navigate first page
  useEffect(() => {
    if (!filter.singleDates?.start) {
      navigate('/welcomer-start-date')
    }
    //
    return () => {}
  }, [filter.singleDates?.start, navigate])
  //
  //
  const MainLoading = isCountriesLoading || isSgsRequestLoaiding || isPageInfoLoading
  //
  //
  return MainLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageTitle} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      {/*  */}
      <DialogModal
        title={t('consent')}
        isOpen={termsModalIsOpen}
        onClose={closeTermsModal}
        src={`${document.location.origin}/consent-dialog`}
        acceptOnClick={() => [
          dispatch(
            setInsurerInfo({
              fieldName: 'consentTerm',
              fieldValue: true,
            }),
          ),
          closeTermsModal(),
        ]}
        //
        declineOnClick={() => [
          dispatch(
            setInsurerInfo({
              fieldName: 'consentTerm',
              fieldValue: false,
            }),
          ),
          closeTermsModal(),
        ]}
      />
      {/*  */}
      <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />

      <Content>
        <Title text={pageTitle} />

        <WelcomerProgressbar stepName={stepName || ''} />

        <MovingPrice price={filter.offerTotalPrice} />

        <WhiteBox>
          <BoxTitle>{pageTitle}</BoxTitle>

          <Inputs>
            {countries && (
              <Dropdown
                title={`${t('cityzenship')}`}
                isSearchable={true}
                isDisabled={
                  (auth?.user?.citizenship && auth.user?.userType === 'User') ||
                  (checkout.insurer.sgsVerification === true && checkout.insurer.cityzenship)
                    ? true
                    : false
                }
                value={countries.find((x) => x.isoCode === checkout.insurer?.cityzenship)?.isoCode}
                options={[
                  ...countries.map((c) => ({
                    value: c.isoCode,
                    label: c.translations?.[lang]?.name,
                  })),
                ]}
                onChange={(value) =>
                  dispatch(
                    setInsurerInfo({
                      fieldName: 'cityzenship',
                      fieldValue: value.value,
                    }),
                  )
                }
              />
            )}

            <Input
              id="welcomer-id-number"
              name="idNumber"
              label={`${t('personalNumber')}`}
              type="text"
              placeholder=""
              value={checkout.insurer.idNumber || ''}
              onChange={(value) => [
                dispatch(
                  setInsurerInfo({
                    fieldName: 'idNumber',
                    fieldValue: value,
                  }),
                ),
                formik.setFieldValue('idNumber', value),
              ]}
              width={'fullWidth'}
              error={(formik.touched.idNumber && formik.errors.idNumber) || formik.errors.idNumber ? true : false}
              errorText={
                (formik.touched.idNumber && formik.errors.idNumber) || formik.errors.idNumber
                  ? formik.errors.idNumber
                  : undefined
              }
              onBlur={formik.handleBlur}
              disabled={auth?.user?.personalNumber && auth.user?.userType === 'User' ? true : false}
            />
            {checkout.insurer.dateOfbirth !== undefined && diffage && diffage < 18 ? (
              <WarningMessage variant="light-red" text={t('ageIsNotValid')} />
            ) : null}

            <Input
              id="welcomer-date-of-birth"
              name="date-of-birth"
              label={`${t('dateOfBirth')}`}
              type="text"
              placeholder=""
              disabled={true}
              value={filter?.welcomersDate?.[0]?.date || ''}
              onChange={() => {}}
              width={'fullWidth'}
            />

            <Input
              id="welcomer-passport-number"
              name="passportNumber"
              label={`${t('passportNumber')}`}
              type="text"
              placeholder=""
              value={checkout.insurer.passportNumber || ''}
              onChange={(value) => [
                dispatch(
                  setInsurerInfo({
                    fieldName: 'passportNumber',
                    fieldValue: value,
                  }),
                ),
                formik.setFieldValue('passportNumber', value),
              ]}
              width={'fullWidth'}
              error={
                (formik.touched.passportNumber && formik.errors.passportNumber) || formik.errors.passportNumber
                  ? true
                  : false
              }
              errorText={
                (formik.touched.passportNumber && formik.errors.passportNumber) || formik.errors.passportNumber
                  ? formik.errors.passportNumber
                  : undefined
              }
              onBlur={formik.handleBlur}
              disabled={auth?.user?.passportNumber && auth.user?.userType === 'User' ? true : false}
            />

            <>
              {checkout.insurer.cityzenship === 'GE' && (
                <Input
                  id="welcomer-georgian-first-name"
                  name="firstNameGe"
                  label={`${t('nameInGeorgia')}`}
                  type="text"
                  placeholder=""
                  value={checkout.insurer.translations?.ge?.firstName || ''}
                  onChange={(value) => [
                    dispatch(
                      setInsurerTranslationInfo({
                        language: 'ge',
                        fieldName: 'firstName',
                        fieldValue: value,
                      }),
                    ),
                    formik.setFieldValue('firstNameGe', value),
                  ]}
                  width={'fullWidth'}
                  error={formik.errors.firstNameGe && checkout.insurer.translations?.ge?.firstName ? true : false}
                  errorText={formik.errors.firstNameGe}
                  onBlur={formik.handleBlur}
                  disabled={
                    (auth.user?.userType === 'User' && auth?.user?.firstNameGe) ||
                    (checkout.insurer.sgsVerification === true && checkout.insurer.translations?.ge?.firstName)
                      ? true
                      : false
                  }
                />
              )}
            </>

            <>
              {checkout.insurer.cityzenship === 'GE' && (
                <Input
                  id="welcomer-georgian-last-name"
                  name="lastNameGe"
                  label={`${t('surnameInGeorgia')}`}
                  type="text"
                  placeholder=""
                  value={checkout.insurer.translations?.ge?.lastName || ''}
                  onChange={(value) => [
                    dispatch(
                      setInsurerTranslationInfo({
                        language: 'ge',
                        fieldName: 'lastName',
                        fieldValue: value,
                      }),
                    ),
                    formik.setFieldValue('lastNameGe', value),
                  ]}
                  width={'fullWidth'}
                  error={formik.errors.lastNameGe && checkout.insurer.translations?.ge?.lastName ? true : false}
                  errorText={formik.errors.lastNameGe}
                  onBlur={formik.handleBlur}
                  disabled={
                    (auth.user?.userType === 'User' && auth?.user?.lastNameGe) ||
                    (checkout.insurer.sgsVerification === true && checkout.insurer.translations?.ge?.lastName)
                      ? true
                      : false
                  }
                />
              )}
            </>

            <Input
              id="welcomer-english-first-name"
              name="firstName"
              label={`${t('nameInEnglish')}`}
              type="text"
              placeholder=""
              value={checkout.insurer.translations?.en?.firstName || ''}
              onChange={(value) => [
                dispatch(
                  setInsurerTranslationInfo({
                    language: 'en',
                    fieldName: 'firstName',
                    fieldValue: value,
                  }),
                ),
                formik.setFieldValue('firstName', value),
              ]}
              width={'fullWidth'}
              error={formik.errors.firstName && checkout.insurer.translations?.en?.firstName ? true : false}
              errorText={formik.errors.firstName}
              onBlur={formik.handleBlur}
              disabled={
                auth.user?.userType === 'User' && auth?.user?.firstName && auth.user.sgsVerification === true
                  ? true
                  : false
              }
            />

            <Input
              id="welcomer-english-last-name"
              name="lastName"
              label={`${t('surnameInEnglish')}`}
              type="text"
              placeholder=""
              value={checkout.insurer.translations?.en?.lastName || ''}
              onChange={(value) => [
                dispatch(
                  setInsurerTranslationInfo({
                    language: 'en',
                    fieldName: 'lastName',
                    fieldValue: value,
                  }),
                ),
                formik.setFieldValue('lastName', value),
              ]}
              width={'fullWidth'}
              error={formik.errors.lastName && checkout.insurer.translations?.en?.lastName ? true : false}
              errorText={formik.errors.lastName}
              onBlur={formik.handleBlur}
              disabled={
                auth.user?.userType === 'User' && auth?.user?.lastName && auth.user.sgsVerification === true
                  ? true
                  : false
              }
            />

            <>
              <ChooseGenderLabel>{t('chooseGender')}</ChooseGenderLabel>
              <GenderBlock
                style={{
                  userSelect: auth.user?.userType === 'User' && auth?.user?.gender ? 'none' : 'unset',
                  //
                  pointerEvents: auth.user?.userType === 'User' && auth?.user?.gender ? 'none' : 'unset',
                }}
              >
                <GenderCard
                  selected={checkout.insurer.gender === 'female'}
                  gender="female"
                  femaleText={`${t('female')}`}
                  onClick={() => [
                    dispatch(
                      setInsurerInfo({
                        fieldName: 'gender',
                        fieldValue: 'female',
                      }),
                    ),
                    formik.setFieldValue('gender', 'female'),
                  ]}
                />

                <GenderCard
                  selected={checkout.insurer.gender === 'male'}
                  gender="male"
                  maleText={`${t('male')}`}
                  onClick={() => [
                    dispatch(
                      setInsurerInfo({
                        fieldName: 'gender',
                        fieldValue: 'male',
                      }),
                    ),
                    formik.setFieldValue('gender', 'male'),
                  ]}
                />
              </GenderBlock>
            </>

            <Checkbox
              id="for-me-frani-terms"
              label={`${t('franiTermsText')}`}
              checked={checkout.insurer.consentTerm || false}
              defaultChecked={checkout.insurer.consentTerm || false}
              onClick={() => setTermsModalIsOpen(true)}
            />

            <>
              {(filter.attachedAddons && filter.attachedAddons.length >= 1) ||
              (filter.groupedAttachedAddons && filter.groupedAttachedAddons.length >= 1) ? (
                <AddonBlock>
                  <hr />
                  <AddonsLabel>{t('additionalCoverages')}</AddonsLabel>

                  <AddonItems>
                    {filter.attachedAddons?.map((atAddon, atAddonIndex) => (
                      <AddonItem key={atAddonIndex}>
                        <Checkbox
                          id="luggage"
                          label={atAddon.addon.addon.translations[lang]?.title || ''}
                          onChange={(value) => alert(value)}
                        />
                        <AddonPriceSpan>
                          {atAddon.addon.paymentType === 'DAILY'
                            ? parseFloat(atAddon.addon.premium) * (filter?.insuranceDays || 0)
                            : parseFloat(atAddon.addon.premium)}{' '}
                          ₾
                        </AddonPriceSpan>
                      </AddonItem>
                    ))}

                    {filter.groupedAttachedAddons?.map((groupAtAddon, groupAtAddonIndex) => (
                      <AddonItem key={groupAtAddonIndex}>
                        <Checkbox
                          id="luggage2"
                          label={groupAtAddon.addon.translations?.[lang]?.title || ''}
                          onChange={(value) => alert(value)}
                        />
                        <AddonPriceSpan>
                          {groupAtAddon.addon.paymentType === 'DAILY'
                            ? groupAtAddon.addon.premium * (filter?.insuranceDays || 0)
                            : groupAtAddon.addon.premium}{' '}
                          ₾
                        </AddonPriceSpan>
                      </AddonItem>
                    ))}
                  </AddonItems>
                </AddonBlock>
              ) : null}
            </>
          </Inputs>
        </WhiteBox>

        <Buttons>
          <NavigationButton
            text={`${t('back')}`}
            buttonType="prev"
            onClick={() => navigate('/welcomer-who-do-you-insure')}
          />
          <NavigationButton
            text={`${t('next')}`}
            buttonType="next"
            disabled={
              formik.isValid === true &&
              checkout.insurer.cityzenship &&
              checkout.insurer.dateOfbirth !== undefined &&
              (checkout.insurer.cityzenship === 'GE'
                ? checkout.insurer.idNumber && checkout.insurer.idNumber.length === 11
                : true) &&
              (checkout.insurer.cityzenship === 'GE'
                ? checkout.insurer.translations?.ge?.firstName &&
                  checkout.insurer.translations?.ge?.firstName.length >= 2
                : true) &&
              (checkout.insurer.cityzenship === 'GE'
                ? checkout.insurer.translations?.ge?.lastName && checkout.insurer.translations?.ge?.lastName.length >= 2
                : true) &&
              (checkout.insurer.cityzenship !== 'GE'
                ? checkout.insurer.passportNumber && checkout.insurer.passportNumber.length >= 1
                : true) &&
              checkout.insurer.translations?.en?.firstName &&
              checkout.insurer.translations?.en?.firstName.length >= 2 &&
              checkout.insurer.translations?.en?.lastName &&
              checkout.insurer.translations?.en?.lastName.length >= 2 &&
              checkout.insurer.gender &&
              checkout.insurer.gender?.length >= 2 &&
              diffage &&
              checkout.insurer.consentTerm === true &&
              diffage >= 18
                ? false
                : true
            }
            onClick={() => navigate('/welcomer-check-information')}
          />
        </Buttons>
      </Content>
      <BackgroundIcon />
    </Wrapper>
  )
}
//
//
// styles
const AddonItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
const AddonItems = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 14px;
`
const AddonPriceSpan = styled.span`
  font-size: 14px;
`
const AddonBlock = styled.div`
  /*  */
  input {
    display: none;
    user-select: none;
    pointer-events: none;
  }
  label {
    padding-left: 0px;
    user-select: none;
    pointer-events: none;
  }
`
const AddonsLabel = styled.label`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  margin-bottom: 25px;
  ${Responsive.mobile} {
    font-size: 14px;
  }
`
const GenderBlock = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 20px;
  grid-row-gap: 0px;
`
const ChooseGenderLabel = styled.label`
  font-size: 14px;
  margin-bottom: -10px;
  color: ${Colors.primaryGrey};
`
const Inputs = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 20px;
  margin-top: 20px;
`
const WhiteBox = styled.div`
  background-color: ${Colors.white};
  margin-block: 32px;
  box-shadow: 0 4px 50px 0 rgba(0, 0, 0, 0.04);
  max-width: 464px;
  margin-inline: auto;
  border-radius: 8px;
  padding: 34px 48px;

  ${Responsive.mobile} {
    padding: 20px;
  }
`
const BoxTitle = styled.h6`
  font-size: 18px;
  color: ${Colors.primaryBlack};
`
const Buttons = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 48px;
  width: min-content;
  margin-inline: auto;
  button {
    width: 175px;
  }

  ${Responsive.mobile} {
    gap: 16px;
    button {
      width: 140px;
    }
  }
`

const Content = styled.div`
  margin-top: 58px;
  z-index: 2;
  padding-inline: 20px;

  ${Responsive.mobile} {
    margin-top: 26px;
  }
`
const Wrapper = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  flex-direction: column;
  background-color: ${Colors.backgroundGrey};
  padding-bottom: 20px;
  min-height: 100vh;
  /*  */
`
export default WelcomerForMe
